import { render, staticRenderFns } from "./forceDown.vue?vue&type=template&id=16901fe0&scoped=true&"
import script from "./forceDown.vue?vue&type=script&lang=js&"
export * from "./forceDown.vue?vue&type=script&lang=js&"
import style0 from "./forceDown.vue?vue&type=style&index=0&id=16901fe0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16901fe0",
  null
  
)

export default component.exports